import React from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'

import { Txt, Card } from '../../../../components'
import {
  getEventAddressToShow,
  getEventLocationToShow
} from '../../../../tools/dataParse'
import { useTheme } from '../../../../theming/ThemeProvider'
import { getEventTypeName, getEventColor } from '../../../../tools/objectMapValues'
import { useMobileStyles } from './useStyles'

export default function EventCard ({ event }) {
  const { theme } = useTheme()
  const styles = useMobileStyles(theme)

  const eventTypeName = getEventTypeName(event.type)
  const eventAddressToShow = getEventAddressToShow(event)
  const eventLocationToShow = getEventLocationToShow(event)

  return (
    <Card
      containerStyle={styles.card}
      contentStyle={[
        styles.content,
        {
          borderLeftColor: theme[getEventColor(event.type)]
        }
      ]}
    >
      <Txt
        text={eventTypeName}
        identity='body2'
      />
      <View style={styles.eventInfoContainer}>
        <Txt
          text={`${eventAddressToShow} ${eventLocationToShow}`}
          identity='body3'
          color='OUTER_SPACE'
          style={styles.rightInfoItem}
        />
        <Txt
          text={event.start}
          identity='body3'
          color='OUTER_SPACE'
          style={styles.leftInfoItem}
        />
      </View>
    </Card>
  )
}

EventCard.propTypes = {
  event: PropTypes.object.isRequired
}

EventCard.defaultProps = {
  event: {}
}
